import { User } from '@/models/user'
import { BaseAPI } from '@/api/base.api'
import { API_URL_AUTH, ID_APP } from '@/commons/config'
import { AxiosObservable } from 'axios-observable/dist/axios-observable.interface'

export class UserAPI extends BaseAPI<User> {
  public signin (usernameOrEmail: string, password: string): AxiosObservable<User> {
    return this.axios.post(`${API_URL_AUTH}`, { usernameOrEmail, password, application: ID_APP })
  }
}
